/* eslint-disable @typescript-eslint/unbound-method */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserModel } from '@app/users/models/user-model';
import { takeUntil } from 'rxjs';
import { BaseComponentDirective } from '@core/component/base.component';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { VerifiedEmailService } from '@app/user-settings/services/verify-email-service';
import { AuthenticationService } from '@app/authentication/services/authentication.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent extends BaseComponentDirective implements OnInit, OnDestroy {
    userId: string;
    user: UserModel;
    userEmailVerified: boolean;
    formGroup: UntypedFormGroup;
    loading: boolean;
    userNotFoundError: boolean;
    constructor(private readonly verifiedEmailService: VerifiedEmailService, private formBuilder: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private _messageService: MessageService) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.loadForm();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
    isControlValid(controlName: string): boolean {
        const control = this.formGroup.controls[controlName];
        return control.valid && (control.dirty || control.touched);
    }

    isControlInvalid(controlName: string): boolean {
        const control = this.formGroup.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }
    loadForm() {
        this.formGroup = this.formBuilder.group({
            email: ['', Validators.compose([Validators.required, Validators.email])],
        });
    }

    getUserVerified(): void {
        this.verifiedEmailService
            .getVerifiedEmail(this.formGroup.value.email as string)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe({
                next: (data) => {
                    window.scrollTo(0, 0);
                    if (data.value === true) {
                        this.sendForgotPasswordEmail(data.id);
                    } else if (data.value === false) {
                        this.userNotFoundError = data.value;
                    }
                },
                error: (error) => {
                    this.userNotFoundError = error.value;
                },
            });
    }

    sendForgotPasswordEmail(id: string) {
        this.authenticationService.sendForgotPasswordEmail(id).pipe(takeUntil(this.onDestroy$)).subscribe(res => {
            if (res) {
                this._messageService.add({
                    key: 'bc',
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Please check your email to reset password',
                });
            } else {
                this._messageService.add({
                    key: 'bc',
                    severity: 'warning',
                    summary: 'Warning',
                    detail: 'Error sending the email',
                });
            }
        });
    }

    submit() {
        this.getUserVerified();
    }
}
